export default {"src":"/_next/static/media/Elite-badge.78c47b77.svg","height":46,"width":46};